import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGhsa = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_20464_5075)",
			children: /* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M6.00024 0C2.68524 0 0.000244141 2.75291 0.000244141 6.15176C0.000244141 8.87392 1.71774 11.1731 4.10274 11.9882C4.40274 12.0421 4.51524 11.8575 4.51524 11.696C4.51524 11.5499 4.50774 11.0655 4.50774 10.5503C3.00024 10.8348 2.61024 10.1735 2.49024 9.82744C2.42274 9.65058 2.13024 9.10461 1.87524 8.9585C1.66524 8.84316 1.36524 8.55864 1.86774 8.55095C2.34024 8.54326 2.67774 8.99695 2.79024 9.18151C3.33024 10.112 4.19274 9.85051 4.53774 9.68903C4.59024 9.28916 4.74774 9.02002 4.92024 8.86623C3.58524 8.71243 2.19024 8.18184 2.19024 5.8288C2.19024 5.15979 2.42274 4.60613 2.80524 4.17551C2.74524 4.02171 2.53524 3.39116 2.86524 2.54529C2.86524 2.54529 3.36774 2.38381 4.51524 3.17585C4.99524 3.03743 5.50524 2.96823 6.01524 2.96823C6.52524 2.96823 7.03525 3.03743 7.51525 3.17585C8.66275 2.37612 9.16525 2.54529 9.16525 2.54529C9.49524 3.39116 9.28524 4.02171 9.22525 4.17551C9.60775 4.60613 9.84024 5.1521 9.84024 5.8288C9.84024 8.18954 8.43775 8.71243 7.10275 8.86623C7.32024 9.05847 7.50774 9.42758 7.50774 10.0043C7.50774 10.8271 7.50025 11.4884 7.50025 11.696C7.50025 11.8575 7.61274 12.0498 7.91274 11.9882C10.2827 11.1731 12.0002 8.86623 12.0002 6.15176C12.0002 2.75291 9.31524 0 6.00024 0Z",
				fill: "currentColor"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_20464_5075",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 12.48,
				height: 12.48,
				fill: "white",
				transform: "translate(-0.23999 -0.240234)"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgGhsa);
export { ForwardRef as ReactComponent };
